/* eslint-disable */

export var PropertyTypeGroupValues;
(function (PropertyTypeGroupValues) {
  PropertyTypeGroupValues.CASA = 'case';
  PropertyTypeGroupValues.NUOVA_COSTRUZIONE = 'nuove-costruzioni';
  PropertyTypeGroupValues.COMMERCIALE = 'commerciale';
  PropertyTypeGroupValues.TERRENO = 'terreni';
  PropertyTypeGroupValues.GARAGE_POSTO_AUTO = 'garage-posti-auto';
  PropertyTypeGroupValues.STANZA = 'stanze';
  PropertyTypeGroupValues.CANTINA_SOLAIO = 'cantine-solai';
}(PropertyTypeGroupValues || (PropertyTypeGroupValues = {})));
export var CasaPropertyTypes;
(function (CasaPropertyTypes) {
  CasaPropertyTypes.APPARTAMENTO = 'appartamento';
  CasaPropertyTypes.ATTICO_MANSARDA = 'attico-mansarda';
  CasaPropertyTypes.BI_TRIFAMILIARE = 'casa-bi-trifamiliare';
  CasaPropertyTypes.CASA_INDIPENDENTE = 'casa-indipendente';
  CasaPropertyTypes.LOFT = 'loft';
  CasaPropertyTypes.RUSTICO_CASALE = 'rustico-casale';
  CasaPropertyTypes.VILLA = 'villa';
  CasaPropertyTypes.VILLETTA_SCHIERA = 'villetta-a-schiera';
  CasaPropertyTypes.BAITA_BUNGALOW_CHALET_TRULLO = 'baita-bungalow-chalet-trullo';
  CasaPropertyTypes.PALAZZO = 'palazzo';
}(CasaPropertyTypes || (CasaPropertyTypes = {})));
export var CommercialePropertyTypes;
(function (CommercialePropertyTypes) {
  CommercialePropertyTypes.ATTIVITA_LICENZA_COMMERCIALE = 'attivita-licenza-commerciale';
  CommercialePropertyTypes.NEGOZIO_LOCALE_COMMERCIALE = 'negozio-locale-commerciale';
}(CommercialePropertyTypes || (CommercialePropertyTypes = {})));
export var TerrenoPropertyTypes;
(function (TerrenoPropertyTypes) {
  TerrenoPropertyTypes.EDIFICABILE = 'terreno-edificabile';
  TerrenoPropertyTypes.AGRICOLO = 'terreno-agricolo';
}(TerrenoPropertyTypes || (TerrenoPropertyTypes = {})));
export var GaragePropertyTypes;
(function (GaragePropertyTypes) {
  GaragePropertyTypes.GARAGE_POSTO_AUTO = 'garage-posto-auto';
}(GaragePropertyTypes || (GaragePropertyTypes = {})));
export var StanzaPropertyTypes;
(function (StanzaPropertyTypes) {
  StanzaPropertyTypes.STANZA = 'stanza';
}(StanzaPropertyTypes || (StanzaPropertyTypes = {})));
export var CantinaPropertyTypes;
(function (CantinaPropertyTypes) {
  CantinaPropertyTypes.CANTINA_SOLAIO = 'cantina-solaio';
}(CantinaPropertyTypes || (CantinaPropertyTypes = {})));
